import React from "react";
import "./MedicineListDetails.css";

const MedicineListDetails = ({ medicines }) => {
  return (
    <div className="main-details">
      <table>
        <thead>
          <tr>
            <th>Medicine Name</th>
            <th>QTY</th>
            <th>Unit</th>
          </tr>
        </thead>
        <tbody>
          {medicines && medicines.length > 0 ? (
            medicines.map((medicine, index) => (
              <tr key={index}>
                <td>{medicine.name || "N/A"}</td>
                <td>{medicine.quantity || "N/A"}</td>
                <td>{medicine.unit || "N/A"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">No medicines found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default MedicineListDetails;
